import React from "react";
import Tabs from "@material-ui/core/Tabs";
import { withStyles } from "@material-ui/core/styles";

export default withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: "#292b2f",
    },
  },
})((props: any) => <Tabs {...props} />);
